import moment from 'moment';

export function changeUtcOffsetTime(momentTime, utcOffset) {
  return momentTime.utc().add(utcOffset, 'hours');
}

export function currentUtcOffsetTime(utcOffset) {
  return changeUtcOffsetTime(moment(), utcOffset);
}
